export var AlertType;
(function (AlertType) {
    AlertType["Critical"] = "critical";
    AlertType["Warning"] = "warning";
    AlertType["Informational"] = "informational";
})(AlertType || (AlertType = {}));
